import axios from 'axios';
import { updateUrlGetParams } from '@/helpers/url';
import WebApi from '../WebApi';
class BookApi extends WebApi {
    async bookDirectAppointment(appointment) {
        const { data } = await axios.post(`${this.urlPrefix}/direct_appointments`, { appointment });
        return data.appointment;
    }
    async bookAppointmentTelecom(appointment) {
        const { data } = await axios.post(`${this.urlPrefix}/telecom_appointments`, { appointment });
        return data.appointment;
    }
    async bookAppointmentBranchPublic(appointment) {
        const { data } = await axios.post(`${this.urlPrefix}/branch_appointments`, { appointment });
        return data.appointment;
    }
    async bookInServicePoint(appointment) {
        const { data } = await axios.post(`${this.urlPrefix}/service_point_appointments`, { appointment });
        return data.appointment;
    }
    async bookInServicePointByPhone(appointment) {
        const { data } = await axios.post(`${this.urlPrefix}/service_point_by_phone_appointments`, { appointment });
        return data.appointment;
    }
    async bookAppointmentOnSite(appointment, id) {
        const { data } = await axios.put(`${this.urlPrefix}/on_site_appointments/${id}/book`, { appointment });
        return data.appointment;
    }
    async bookAppointmentOnSiteInBranch(appointment, id) {
        const { data } = await axios.put(`${this.urlPrefix}/on_site_in_branch_appointments/${id}/book`, { appointment });
        return data.appointment;
    }
    async bookAppointmentBranchPrivate(appointment) {
        const { data } = await axios.post(`${this.urlPrefix}/branch_private_appointments`, { appointment });
        return data.appointment;
    }
    async bookAppointmentManually(payload) {
        const { data } = await axios.post(`${this.urlPrefix}/appointments`, {
            'appointment': payload,
        });
        return data.appointment;
    }
    async getQuestions(currentFlow) {
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/questions?flow=updating`, {
            flow: currentFlow,
        }));
        return data.questions;
    }
    async confirmRemoteAvailability(availability) {
        const { data } = await axios.post(`${this.urlPrefix}/availabilities/confirm_remote`, {
            availability,
        });
        return data;
    }
}
const bookApi = new BookApi();
export { bookApi as BookApi, };
